// collection-scripts.js

document.addEventListener("DOMContentLoaded", function() {
    // Add statt ... UVP to product cards
    function add_statt_uvp(){
        const priceWraps = document.querySelectorAll('.spf-product-card__price-wrapper');

        priceWraps.forEach(function(priceWrap) {
            if (!priceWrap.classList.contains('changed-style')) {
                const salePrice = priceWrap.querySelector('.spf-product-card__saleprice');
                const oldPrice = priceWrap.querySelector('.spf-product-card__oldprice');

                if (salePrice && oldPrice) {
                    const oldPriceText = oldPrice.innerText;
                    oldPrice.innerText = `statt ${oldPriceText} UVP`;
                    priceWrap.classList.add('changed-style');
                }
            }
        });
    }

    function add_statt_uvp_mut_observer(){
        const gfGrid = document.querySelector('#gf-grid [data-sectionid]');
        if (!gfGrid) return;

        const MutObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

        if (MutObserver) {
            const gfGridObserver = new MutObserver(function(mutationRecords) {
                mutationRecords.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node instanceof HTMLElement) {
                            add_statt_uvp();
                        }
                    });
                });
            });

            gfGridObserver.observe(gfGrid, {
                childList: true, 
                characterDataOldValue: true,
                attributes: true
            });
            console.log('add_statt_uvp_mut_observer INIT');
        }
    }

    // Вызов функций с задержкой
    const delays = [3000, 4000, 5000];
    delays.forEach(function(delay) {
        setTimeout(function(){
            add_statt_uvp();
            add_statt_uvp_mut_observer();
        }, delay);
    });

    // Обработчики для .results--container
    const prodResults = document.querySelector('.results--container.hidden-results');

    if (prodResults) {
        setTimeout(function(){
            prodResults.classList.remove('hidden-results');
        }, 1500);
    }

    const collectionSection = document.querySelector('[data-sectionid="static-collection"]');
    if (collectionSection) {
        collectionSection.addEventListener("mouseover", showForm);
        collectionSection.addEventListener("mouseout", showForm);
        collectionSection.addEventListener("touchstart", showForm);

        function showForm(e) {
            const prodCards = document.querySelectorAll('.spf-product-card');

            prodCards.forEach(function(card) {
                if (e.target.closest('.spf-product-card') === card) {
                    card.classList.add('show-form');
                } else {
                    card.classList.remove('show-form');
                }
            });
        }
    }

    // Обработчик кликов для .results--container
    const resultsContainer = document.querySelector('.results--container');
    if (resultsContainer) {
        resultsContainer.addEventListener('click', function(e){
            if (e.target.closest('.gf-clear') || e.target.closest('.gf-option-399967 a')){
                const url = location.href;
                const sportartNavItems = document.querySelectorAll('.sportart-nav-item > a');

                if (url.includes('gf_399967=')) {
                    let fpart = url.split(/gf_399967\=/)[1];
                    if (fpart.includes('&gf')) {
                        fpart = fpart.split(/\&gf/)[0];
                    }

                    let sportartenStr = fpart.replace(/Erlebnisbereich\_/g, '').replace(/\%2F/g, '/').split(/\%2B/);
                    let sportartName;

                    sportartNavItems.forEach(function(sportartNavItem){
                        sportartNavItem.classList.remove('chosen-collection-link');
                        sportartNavItem.closest('.sportart-nav-item').classList.remove('active-third-lvl');
                    });

                    sportartenStr.forEach(function(item){
                        sportartNavItems.forEach(function(sportartNavItem){
                            sportartName = sportartNavItem.innerText.trim();
                            if (sportartName === item){
                                sportartNavItem.classList.add('chosen-collection-link');
                                const collectionsNavItemMain = sportartNavItem.closest('.collections-nav__item-main');
                                if (collectionsNavItemMain && !collectionsNavItemMain.classList.contains('active-tree-collection')){
                                    collectionsNavItemMain.classList.add('active-tree-collection');
                                }
                                const sportartNavItemElem = sportartNavItem.closest('.sportart-nav-item');
                                if (sportartNavItemElem){
                                    sportartNavItemElem.classList.add('active-third-lvl');
                                }
                            }
                        });
                    });
                } else {
                    const sportartNavItems = document.querySelectorAll('.sportart-nav-item > a');
                    sportartNavItems.forEach(function(sportartNavItem){
                        sportartNavItem.classList.remove('chosen-collection-link');
                        sportartNavItem.closest('.sportart-nav-item').classList.remove('active-third-lvl');
                        const collectionsNavItemMain = sportartNavItem.closest('.collections-nav__item-main');
                        if (collectionsNavItemMain){
                            collectionsNavItemMain.classList.remove('active-tree-collection');
                        }
                    });
                }
            }
        });
    }

    // Инициализация классов на основе выбранных элементов
    window.addEventListener("DOMContentLoaded", function() {
        const chosen_thirdLvl_item = document.querySelector('.chosen_third-lvl_item');
        if (chosen_thirdLvl_item) {
            const collectionsNavItemMain = chosen_thirdLvl_item.closest('.collections-nav__item-main');
            if (collectionsNavItemMain){
                collectionsNavItemMain.classList.add('active-tree-collection');
            }
            const collectionsNavItem = chosen_thirdLvl_item.closest('.collections-nav__item');
            if (collectionsNavItem){
                collectionsNavItem.classList.add('active-third-lvl');
            }
        }

        const chosen_link = document.querySelector('.chosen-collection-link');
        if (chosen_link) {
            const collectionsNavItemMain = chosen_link.closest('.collections-nav__item-main');
            if (collectionsNavItemMain){
                collectionsNavItemMain.classList.add('active-tree-collection');
            }
            const hasThirdLvl = chosen_link.closest('.has-third-lvl');
            if (hasThirdLvl){
                hasThirdLvl.classList.add('active-third-lvl');
            }
        }

        // Дополнительная инициализация с задержкой
        setTimeout(function(){
            const chosen_thirdLvl_item = document.querySelector('.chosen_third-lvl_item');
            if (chosen_thirdLvl_item) {
                const collectionsNavItemMain = chosen_thirdLvl_item.closest('.collections-nav__item-main');
                if (collectionsNavItemMain && !collectionsNavItemMain.classList.contains('active-tree-collection')) {
                    collectionsNavItemMain.classList.add('active-tree-collection');
                }
                const collectionsNavItem = chosen_thirdLvl_item.closest('.collections-nav__item');
                if (collectionsNavItem && !collectionsNavItem.classList.contains('active-third-lvl')) {
                    collectionsNavItem.classList.add('active-third-lvl');
                }
            }

            const chosen_link = document.querySelector('.chosen-collection-link');
            if (chosen_link) {
                const collectionsNavItemMain = chosen_link.closest('.collections-nav__item-main');
                if (collectionsNavItemMain && !collectionsNavItemMain.classList.contains('active-tree-collection')) {
                    collectionsNavItemMain.classList.add('active-tree-collection');
                }
            }
        }, 4000);
    });
});
